import { TApiSavedReport } from "@timenotes/shared/src/services/saved-reports/saved-reports-types"

interface Props {
  savedReport?: TApiSavedReport
}

export function SavedReportDescription(props: Props) {
  const {
    savedReport
  } = props

  if (savedReport?.id && savedReport.description && savedReport.description != '') {
    return (
      <div style={{ marginBottom: '10px', paddingLeft: '10px' }}>
        {savedReport.description}
      </div>
    )
  }

  return null
}